var selectionCtrlDesk = document.querySelector(".store-selection-ctrl"),
  selectionListDesk = document.querySelector(".store-selection-list"),
  selectionListItemsDesk = document.querySelectorAll(".store-selection-list-item"),
  storeNameDesk = document.querySelector("#store--name"),
  storeSelectionButtonDesk = document.querySelector(".store-selection-popup--button"),
  modalClose = document.querySelector(".store-selection-popup--close");

var storeURL = "self",
  visitingFrom = "AUS",
  visitingCur = "AUD",
  flagClass = "";

var europeanCountries = [
  "Europe", "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
  "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland",
  "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta",  "Poland",
  "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland",
  "Norway"
];

var storeChecked = localStorage.getItem("storeChecked");
var urlParam = location.search.indexOf("redirectFrom");
if (storeChecked || urlParam !== -1) {
  document.querySelector(".store-selecetion-popup").style.display = "none";
} 

if (urlParam !== -1) {
  var urlParams = new URLSearchParams(window.location.search);
  let store = urlParams.get("redirectFrom");
  if (store) {
    store = store.replace("%20", "");
    localStorage.setItem("visitingFrom", store);
    localStorage.setItem("storeChecked", "true");
  }
}

function rebuildSelectionListDesk(current) {
  selectionListItemsDesk.forEach(function (el) {
    el.style.display = (current === el) ? "none" : "block";
  });
}

function showVisitingFrom() {
  var text = localStorage.getItem("visitingFrom");
  document.querySelectorAll(
    ".store-selecetion-popup .visiting-from--text .current-country"
  ).forEach(el => {
    if (el.classList.length > 1) el.classList.remove(el.classList.item(1));
  });

  
  if (europeanCountries.includes(text)) {
    setPopupState("europe", "EUR", 'Europe', "EUR");
    $(".countrynameselect").html(text);
    console.log('tesssttt' + text)
    $(`.store-selecetion-popup .store-selection-list-item.europe`).hide();
    storeSelectionButtonDesk.innerText = `Go to EUROPE`;
    return;
  }

  switch (text) {
    case "Australia":
      setPopupState("au", "AUS", "Australia", "AUD");
      storeSelectionButtonDesk.innerText = "Go to Australia";
      break;
    case "United Kingdom":
      setPopupState("gbp", "UK", "United Kingdom", "GBP");
      $(".countrynameselect").html("United Kingdom");
      storeSelectionButtonDesk.innerText = "Go to United Kingdom";
      break;
    case "New Zealand":
      setPopupState("nz", "NZ", "New Zealand", "NZD");
      storeSelectionButtonDesk.innerText = "Go to New Zealand";
      break;
    case "International":
      setPopupState("int", "INT", "International", "USD");
      storeSelectionButtonDesk.innerText = "Go to International";
      break;
    case "United States":
      setPopupState("usd", "USA", "United States", "USD");
      storeSelectionButtonDesk.innerText = "Go to United States";
      break;
    case "Singapore":
      setPopupState("sgd", "SGP", "Singapore", "SGD");
      storeSelectionButtonDesk.innerText = "Go to Singapore";
      break;
    case "The Netherlands":
      setPopupState("euro", "EUR", "Netherlands", "EUR");
      storeSelectionButtonDesk.innerText = "Go to Netherlands";
      break;
    case "Netherlands":
      setPopupState("euro", "EUR", "Netherlands", "EUR");
      storeSelectionButtonDesk.innerText = "Go to Netherlands";
      break;  
  }
}

function setPopupState(flag, abbr, name, cur) {
  document.querySelectorAll(
    ".store-selecetion-popup .visiting-from--text .current-country"
  ).forEach(el => {
    el.classList.add(flag);
    el.innerText = abbr;
  });
  document.querySelectorAll(".store-selecetion-popup .store-country").forEach(el => {
    el.classList.add(flag);
    el.innerText = name;
  });
  $(`.store-selecetion-popup .store-selection-list-item.${flag}`).hide();
  visitingCur = cur;
  visitingFrom =  name;
  console.log(visitingCur + ' ddd')
}

function showSelectionPopup() {
  document.querySelector(".store-selecetion-popup").style.display = "flex";
}

selectionCtrlDesk.addEventListener("click", function () {
  selectionListDesk.classList.toggle("is-open");
});

selectionListItemsDesk.forEach(function (item) {
  item.addEventListener("click", function () {
    storeURL = item.getAttribute("data-link");
    selectionListDesk.classList.remove("is-open");
    storeNameDesk.className = "";
    flagClass = item.classList[1];
    storeNameDesk.innerText = item.innerText;
    storeNameDesk.classList.add("store--name", flagClass);
    visitingFrom = item.innerText;
    visitingCur = item.getAttribute("data-currency");
    storeSelectionButtonDesk.innerText = `Go to ${item.innerText}`;
    rebuildSelectionListDesk(item);
  });
});

storeSelectionButtonDesk.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
  localStorage.setItem("visitingFrom", visitingFrom);

  if (visitingCur === "EUR" || visitingCur === "GBP") {
    window.location.href = `https://www.bhumi-organic.com/?redirectFrom=${visitingFrom}`;
  } else if (visitingCur !== "AUD" && visitingCur !== "NZD") {
    window.location.href = `https://bhumiorganic.com/?redirectFrom=${visitingFrom}`;
  } else {
    document.querySelector(".store-selecetion-popup").style.display = "none";
    $(".currency-selector-auto select").val(visitingCur);
    $(".currency-selector-auto form").submit();
  }
});

modalClose.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
  localStorage.setItem("visitingFrom", "Australia");
  document.querySelector(".store-selecetion-popup").style.display = "none";
});

document.addEventListener('showVisitingFrom', () => {
    showVisitingFrom();
});

